<template>
    <IconBase  v-bind="$props" v-on="$listeners">
        <path d="M18.75 13.8287C15.6625 17.0625 12.5738 25 12.5738 25C12.5738 25 8.16125 13.8287 3.75 11.25"
            stroke="#656565" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M25.62 6.97127L26.1525 12.5013C26.4975 16.0888 23.8087 19.2825 20.2212 19.6288C16.7012 19.9663 13.5125 17.3938 13.1737 13.8738C13.0931 13.0367 13.178 12.192 13.4238 11.3878C13.6697 10.5836 14.0715 9.83577 14.6064 9.1869C15.1412 8.53803 15.7987 8.00088 16.5412 7.60613C17.2837 7.21139 18.0967 6.96678 18.9337 6.88627L24.8287 6.31877C24.9236 6.30964 25.0192 6.31927 25.1103 6.34712C25.2014 6.37497 25.2861 6.42049 25.3596 6.48109C25.433 6.54168 25.4939 6.61616 25.5386 6.70027C25.5832 6.78438 25.6109 6.87647 25.62 6.97127Z"
            stroke="#656565" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
   </IconBase>
</template>

<script>
import IconBase from './iconBase/IconBase.vue'
import iconProps from './iconBase/iconProps.js'

export default {
  components: { IconBase },
  props: {
    ...iconProps,
    height: {
        ...iconProps.height,
        default: 30,
    },
    width: {
        ...iconProps.width,
        default: 30,
    },
    viewBox: {
        ...iconProps.viewBox,
        default: "0 0 30 30",
    }
  },
}
</script>